import React from 'react'

import { MedicalRecordForm } from 'models/MedicalRecord/MedicalRecordForm.type'

import { ListField } from '../components/ListField'
import { ReadOnlyField } from '../components/ReadOnlyField'
import {
  PATIENT_CASE_COMPLEXITY_COLORS,
  PATIENT_CASE_COMPLEXITY_LABELS,
  formatBoolean,
} from '../utils/fieldLabels'
import { formatDiagnosticsList, formatMedicationsList } from '../utils/formatters'

import * as S from '../styles'

interface EvolutionViewProps {
  form: MedicalRecordForm
}

export function EvolutionView({ form }: EvolutionViewProps): JSX.Element {
  return (
    <S.Section>
      <ReadOnlyField
        label='Breve descrição e indicação clínica'
        value={form.patient_case_description}
      />
      <ReadOnlyField
        label='De acordo com a sua avaliação, qual é a complexidade atual do caso?'
        value={
          form.patient_case_complexity
            ? PATIENT_CASE_COMPLEXITY_LABELS[form.patient_case_complexity] ?? form.patient_case_complexity
            : null
        }
        valueColor={
          form.patient_case_complexity
            ? PATIENT_CASE_COMPLEXITY_COLORS[form.patient_case_complexity]
            : undefined
        }
      />
      <ListField
        label='Medicação de uso contínuo'
        items={formatMedicationsList(form)}
      />
      <ListField
        label='Hipótese(s) diagnóstica(s) – CID'
        items={formatDiagnosticsList(form)}
      />
      <ReadOnlyField
        label='Encaminhamento a profissionais da saúde'
        value={form.referral_to_healthcare_professional}
      />
      <ReadOnlyField
        label='Paciente possui ideação suicida?'
        value={formatBoolean(form.has_suicidal_ideation)}
      />
    </S.Section>
  )
}
